import { render, staticRenderFns } from "./UserKpi.vue?vue&type=template&id=709a22e8&scoped=true&"
import script from "./UserKpi.vue?vue&type=script&lang=js&"
export * from "./UserKpi.vue?vue&type=script&lang=js&"
import style0 from "./UserKpi.vue?vue&type=style&index=0&id=709a22e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709a22e8",
  null
  
)

export default component.exports